module.exports = __webpack_public_path__ + "img/yt-red.f80b1dff.svg";